// js/common/cta.js
import { gsap, ScrollTrigger } from "./gsap";

(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const section = document.querySelector(".p-common-cta.js-contact-parallax");
  if (!section) return;
  if (section.dataset.parallaxInit === "1") return;
  section.dataset.parallaxInit = "1";

  const refreshAfterImages = (cb) => {
    const imgs = section.querySelectorAll("img");
    if (!imgs.length) {
      cb?.();
      ScrollTrigger.refresh();
      return;
    }
    let pending = 0;
    imgs.forEach((img) => {
      if (!img.complete) {
        pending++;
        const done = () => {
          if (--pending === 0) {
            cb?.();
            ScrollTrigger.refresh();
          }
        };
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
      }
    });
    if (pending === 0) {
      cb?.();
      ScrollTrigger.refresh();
    }
  };

  const centerStrip = (stripEl) => {
    if (!stripEl) return;
    const imgs = stripEl.querySelectorAll("img");
    if (!imgs.length) return;

    const frameH = stripEl.parentElement?.clientHeight ?? 0;
    const imgH = imgs[0].getBoundingClientRect().height || 300;
    const totalH = imgH * imgs.length;

    const offsetY = -((totalH - frameH) / 2);
    gsap.set(stripEl, { y: offsetY });
  };

  const setupBaseOffsets = () => {
    centerStrip(section.querySelector(".js-parallax-left"));
    centerStrip(section.querySelector(".js-parallax-center"));
    centerStrip(section.querySelector(".js-parallax-right"));
  };

  // ---- パララックス本体 ----
  const mm = gsap.matchMedia();

  function setupParallax({
    lrFrom, lrTo, cFrom, cTo,
    lrScaleFrom, lrScaleTo, cScaleFrom, cScaleTo,
    scrub,
  }) {
    const commonST = {
      trigger: section,
      start: "top bottom",
      end: "bottom top",
      scrub,
      invalidateOnRefresh: true,
    };

    // left/right
    gsap.fromTo(
      section.querySelectorAll(".js-parallax-left, .js-parallax-right"),
      { yPercent: lrFrom, scale: lrScaleFrom, immediateRender: false },
      { yPercent: lrTo,   scale: lrScaleTo,   ease: "none", scrollTrigger: { ...commonST } }
    );

    // center
    gsap.fromTo(
      section.querySelectorAll(".js-parallax-center"),
      { yPercent: cFrom, scale: cScaleFrom, immediateRender: false },
      { yPercent: cTo,   scale: cScaleTo,   ease: "none", scrollTrigger: { ...commonST } }
    );
  }

  // ---- PC/タブレット ----
  mm.add("(min-width: 769px)", () => {
    refreshAfterImages(() => {
      setupBaseOffsets();
      setupParallax({
        lrFrom: -75, lrTo: 75, cFrom: 75, cTo: -75,
        lrScaleFrom: 1.05, lrScaleTo: 1.0,
        cScaleFrom: 1.0,  cScaleTo: 1.05,
        scrub: 1.2,
      });
    });
  });

  // ---- SP ----
  mm.add("(max-width: 768px)", () => {
    refreshAfterImages(() => {
      setupBaseOffsets();
      setupParallax({
        lrFrom: -50, lrTo: 50, cFrom: 50, cTo: -50,
        lrScaleFrom: 1.05, lrScaleTo: 1.0,
        cScaleFrom: 1.0,  cScaleTo: 1.08,
        scrub: 0.8,
      });
    });
  });

  // ---- クリーンアップ（ページ離脱／BFCache等）----
  const cleanup = () => {
    try {
      ScrollTrigger.getAll().forEach((st) => {
        const trg = st.trigger;
        if (trg && section.contains(trg)) st.kill();
      });
    } catch (_) {}
    try { mm.revert(); } catch (_) {}
    delete section.dataset.parallaxInit;
  };

  window.addEventListener("pagehide", cleanup, { once: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") cleanup();
  });
})();
